import {
  LOADING,
  SUCCESS,
} from './NotificationsActions';

const INITIAL_STATE = {
  isLoading: false,
  isLoaded: false,
  notifications: {
    list: [],
    enrolledSp: false,
  },
};

const NotificationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS: {
      return { ...state, notifications: action.data, isLoading: false, isLoaded: true };
    }
    default:
      return state;
  }
};

export default NotificationsReducer;
